/**
 * On the asset page, for the person whose refinement of it is running or ready (`AssetOut.my_refinement`): a notice
 * linking to the review page. While it runs, its status is asked every 3 s so the notice turns into "ready" in place.
 */

import { Link } from 'react-router-dom';
import { WandSparkles } from 'lucide-react';

import { useExtractionStatus } from '@/api/queries';
import type { MyRefinement } from '@/api/types/refinements';

const WORDS = {
  queued: { text: 'Refining…', link: 'Follow the refinement' },
  running: { text: 'Refining…', link: 'Follow the refinement' },
  succeeded: { text: 'A refinement is ready to review', link: 'Review the changes' },
  failed: { text: 'The refinement failed', link: 'See why' },
};

export function RefineNotice({ assetId, refinement }: { assetId: string; refinement: MyRefinement }) {
  const status = useExtractionStatus(refinement.status === 'succeeded' ? null : refinement.id);
  const words = WORDS[status.data?.status ?? refinement.status];
  return (
    <div className="alert alert-info form-alert" role="status">
      <WandSparkles aria-hidden="true" />
      <div className="a-body">
        <b>{words.text}</b> <Link to={`/assets/${assetId}/refine/${refinement.id}`}>{words.link}</Link>
      </div>
    </div>
  );
}
